import Service from "../Service";
import Vue from "vue";
const resource = "general/Notifications/";

export default {
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },
};